import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
// import moment from 'moment';
import moment from 'moment-timezone';
import { browserHistory } from 'react-router';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import withGoBack from '../../common/withGoBack';
import withUser from '../../common/withUser';
import withScanInventory from '../../common/withScanInventory';
import withScanInventoryScanner from '../../common/withScanInventoryScanner';
import withSingleScanSession from '../../common/withSingleScanSession';
import withOnline from '../../common/withOnline';
import {
  onGoBack, screenWidth
} from '../../common/globals';
import Bugsnag from '../../helpers/bugsnag';
import { findLot, findProduct } from '../../helpers/find-product';
import {
  insertScanInventory,
  getInventoryBySessionID,
  getProduct,
  getConsignmentByProductNo,
  getConsignmentByProductNoAndLotNo,
  getConsignmentByProductNoToArray,
} from '../../utils/db';
import ProductSaveWithoutLot from '../../components/Models/ProductSaveWithoutLot';
import ManuallyProductWarnModal from '../../components/Models/ManuallyProductWarnModal';
import AlertConsignmentInventoryModal from '../../components/Models/AlertConsignmentInventory';
import AlertExpireProductModal from '../../components/Models/AlertExpireProductModal';
import EnterProductNoManually from '../../components/Models/EnterProductNoManually';
import ProductQuantityModal from '../../components/Models/ProductQuantity';
import ProductNoRequiredModal from '../../components/Models/ProductNoRequired';
import ErrorBeep from '../../assets/sounds/scanError.wav';
import SuccessBeep from '../../assets/sounds/scanSuccess.wav';
import DoneBtnOnManualProductModal from '../../components/Models/DoneBtnOnManualProduct';
import WrongProductBarCodeScanned from '../../components/Models/WrongProductBarCodeScanned';
import WrongLotBarCodeScanned from '../../components/Models/WrongLotBarCodeScanned';
import Scanner from '../../components/commonComponents/Scanner/Scanner';

class ScanInventory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: new Date(),
      productCount: 0,
      product: {},
      isScanProduct: true,
      isScanLot: true,
      ProductNo: '',
      LotNo: '',
      ExpireDate: '',
      isScanExpiry: true,
      isSkipLot: false,
      selectedQuantity: 1,
      isScanner: false,
      onlineEngineLocation: 'https://cdn.jsdelivr.net/npm/scandit-sdk@5.11.1/build/',
      offlineEngineLocation: '/assets/js/scandit-sdk@5.11.1/build/',
      isClickContinue: '',
      isScannerKeyboard: false,
      isSaveProductBtn: false,
      scanPaused: true,
    };
    this.productSaveWithoutLotModal = null;
    this.manuallyProductWarnModal = null;
    this.alertConsignmentInventoryModal = null;
    this.alertExpireProductModal = null;
    this.enterProductNoManuallyModal = null;
    this.productQuantityModal = null;
    this.isScanProgress = false;
    this.productNoRequiredModal = null;
    this.donebtnOnManuaProductModal = null;
    this.wrongProductBarCodeScannedModal = null;
    this.wrongLotBarCodeScannedModal = null;
  }

  async componentDidMount() {
    try {
      const { scanInventory, scanInventoryScanner: { scanner } } = this.props;
      const inventoryRes = await getInventoryBySessionID(scanInventory.SessionID);
      this.setState({
        product: scanInventory,
        productCount: inventoryRes.length
      });
      if (scanner === true) {
        this.setState({ isScanner: true });
      } else {
        this.setState({ isScanner: false });
      }

      this.productSaveWithoutLotModal = new window.bootstrap.Modal(window.$('#productSaveWithoutLotModal'));
      this.manuallyProductWarnModal = new window.bootstrap.Modal(window.$('#manuallyProductWarnModal'));
      this.alertConsignmentInventoryModal = new window.bootstrap.Modal(window.$('#alertConsignmentInventoryModal'));
      this.alertExpireProductModal = new window.bootstrap.Modal(window.$('#alertExpireProductModal'));
      this.enterProductNoManuallyModal = new window.bootstrap.Modal(window.$('#enterProductNoManuallyModal'));
      this.productQuantityModal = new window.bootstrap.Modal(window.$('#productQuantityModal'));
      this.productNoRequiredModal = new window.bootstrap.Modal(window.$('#productNoRequiredModal'));
      this.donebtnOnManuaProductModal = new window.bootstrap.Modal(window.$('#doneBtnOnManualProductModal'));
      this.wrongProductBarCodeScannedModal = new window.bootstrap.Modal(window.$('#wrongProductBarCodeScannedModal'));
      this.wrongLotBarCodeScannedModal = new window.bootstrap.Modal(window.$('#wrongLotBarCodeScannedModal'));
      document.getElementById('expireDate').setAttribute('readonly', 'readonly');

      // To calculate screen height in small device browser
      // window.addEventListener('resize', () => {
      //   // We execute the same script as before
      //   const vh = window.innerHeight * 0.01;
      //   document.documentElement.style.setProperty('--vh', `${vh}px`);
      // });

      window.addEventListener('resize', () => {
        document.querySelector(':root').style
          .setProperty('--vh', `${window.innerHeight / 100}px`);
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onScanner = () => {
    try {
      const { isScanner, isScanProduct } = this.state;
      const { setScanInventoryScanner } = this.props;
      this.setState({ isScanner: !isScanner, isScanProduct: !isScanProduct });
      if (isScanner === true) {
        window.$('#ProductNoBt').val('');
        window.$('#LotNoBt').val('');
        this.setState({ isScanProduct: true });
        setScanInventoryScanner({ scanner: false });
      } else {
        setTimeout(() => {
          window.$('#ProductNoBt').focus();
          // Stop keyboard events for BT Scanner
          // window.$(() => {
          //   window.$('#ProductNoBt').keypress((event) => {
          //     event.preventDefault();
          //     return false;
          //   });
          // });
          // window.$(() => {
          //   window.$('#LotNoBt').keypress((event) => {
          //     event.preventDefault();
          //     return false;
          //   });
          // });
        }, 500);
        this.setState({ isSaveProductBtn: false });
        setScanInventoryScanner({ scanner: true });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onScan = (data) => {
    const scanData = { data, key: 0 };
    this._onFindProductAndLot(scanData, 'scan');
    this.setState({ scanPaused: true });
  }

  _onSaveScanProduct = async (value) => {
    try {
      const {
        setScanInventory,
        scanInventory,
        user: { selectedTeam: { timezone } }
      } = this.props;
      const {
        product, selectedQuantity, isSkipLot
      } = this.state;
      scanInventory.inventoryId = moment().format('_DDMMMYYYY_hhmmssA');
      const inventoryRes = await getInventoryBySessionID(scanInventory.SessionID);
      if (value === 'plus' && scanInventory.ProductNo !== '') {
        this.setState({
          productCount: inventoryRes.length + 1,
          isScanProduct: true
          // isScanProduct: false
        }, () => {
          window.$('#ProductNo').focus();
        });
      }
      this.setState({
        ProductNo: '',
        LotNo: '',
        ExpireDate: ''
      });
      if (scanInventory.ProductNo !== '' && (scanInventory.LotNo !== '' || scanInventory.ExpireDate !== '')) {
        if ((scanInventory.ProductEnterType === 'MANUAL'
          || scanInventory.LotEnterType === 'MANUAL'
          || scanInventory.ExpDateEnterType === 'MANUAL')
          && selectedQuantity >= 1) {
          scanInventory.ScanDate = moment().tz(timezone).format('YYYY-MM-DD HH:mm:ss.SSS');
          // scanInventory.ScanDate = moment().format('YYYY-MM-DD HH:mm:ss.SSS');
          // scanInventory.SessionDate;
          // scanInventory.SessionDate = moment().tz(timezone).format('YYYY-MM-DD HH:mm:ss.SSS');
          // scanInventory.SessionDate = moment().format('YYYY-MM-DD HH:mm:ss.SSS');
          scanInventory.ExpireDate = (scanInventory.ExpireDate === '' || scanInventory.ExpireDate === null)
            ? '' : moment(scanInventory.ExpireDate).format('MM/DD/YYYY');
          scanInventory.inventoryId = moment().format('_DDMMMYYYY_hhmmss.SSSA');
          scanInventory.Qty = Number(selectedQuantity);
          await insertScanInventory(scanInventory);
          scanInventory.ExpireDate = (scanInventory.ExpireDate === '' || scanInventory.ExpireDate === null) ? '' : new Date(scanInventory.ExpireDate);
          this.setState({
            productCount: inventoryRes.length + 1,
            ProductNo: '',
            LotNo: '',
            ExpireDate: ''
          });
        } else {
          for (let quantity = 0; quantity < selectedQuantity; quantity++) {
            scanInventory.Qty = 1;
            scanInventory.ScanDate = moment().tz(timezone).format('YYYY-MM-DD HH:mm:ss.SSS');
            // scanInventory.ScanDate = moment().format('YYYY-MM-DD HH:mm:ss.SSS');
            // scanInventory.SessionDate;
            // scanInventory.SessionDate = moment().tz(timezone).format('YYYY-MM-DD HH:mm:ss.SSS');
            // scanInventory.SessionDate = moment().format('YYYY-MM-DD HH:mm:ss.SSS');
            scanInventory.ExpireDate = (scanInventory.ExpireDate === '' || scanInventory.ExpireDate === null)
              ? '' : moment(scanInventory.ExpireDate).format('MM/DD/YYYY');
            scanInventory.inventoryId = moment().format('_DDMMMYYYY_hhmmss.SSSA');
            insertScanInventory(scanInventory);
            scanInventory.ExpireDate = (scanInventory.ExpireDate === '' || scanInventory.ExpireDate === null) ? '' : new Date(scanInventory.ExpireDate);
            this.setState({
              productCount: Number(inventoryRes.length) + Number(selectedQuantity)
            });
          }
        }
      } else if (scanInventory.ProductNo !== '' && isSkipLot === false) {
        if ((scanInventory.ProductEnterType === 'MANUAL'
          || scanInventory.LotEnterType === 'MANUAL'
          || scanInventory.ExpDateEnterType === 'MANUAL')
          && selectedQuantity > 1) {
          scanInventory.ScanDate = moment().tz(timezone).format('YYYY-MM-DD HH:mm:ss.SSS');
          // scanInventory.ScanDate = moment().format('YYYY-MM-DD HH:mm:ss.SSS');
          // scanInventory.SessionDate;
          // scanInventory.SessionDate = moment().tz(timezone).format('YYYY-MM-DD HH:mm:ss.SSS');
          // scanInventory.SessionDate = moment().format('YYYY-MM-DD HH:mm:ss.SSS');
          scanInventory.ExpireDate = (scanInventory.ExpireDate === '' || scanInventory.ExpireDate === null)
            ? '' : moment(scanInventory.ExpireDate).format('MM/DD/YYYY');
          scanInventory.inventoryId = moment().format('_DDMMMYYYY_hhmmss.SSSA');
          scanInventory.Qty = Number(selectedQuantity);
          await insertScanInventory(scanInventory);
          scanInventory.ExpireDate = (scanInventory.ExpireDate === '' || scanInventory.ExpireDate === null) ? '' : new Date(scanInventory.ExpireDate);
          this.setState({
            productCount: inventoryRes.length + 1,
            ProductNo: '',
            LotNo: '',
            ExpireDate: ''
          });
        } else {
          for (let quantity = 0; quantity < selectedQuantity; quantity++) {
            scanInventory.Qty = 1;
            scanInventory.ScanDate = moment().tz(timezone).format('YYYY-MM-DD HH:mm:ss.SSS');
            // scanInventory.ScanDate = moment().format('YYYY-MM-DD HH:mm:ss.SSS');
            // scanInventory.SessionDate;
            // scanInventory.SessionDate = moment().tz(timezone).format('YYYY-MM-DD HH:mm:ss.SSS');
            // scanInventory.SessionDate = moment().format('YYYY-MM-DD HH:mm:ss.SSS');
            scanInventory.ExpireDate = (scanInventory.ExpireDate === '' || scanInventory.ExpireDate === null)
              ? '' : moment(scanInventory.ExpireDate).format('MM/DD/YYYY');
            scanInventory.inventoryId = moment().format('_DDMMMYYYY_hhmmss.SSSA');
            insertScanInventory(scanInventory);
            scanInventory.ExpireDate = (scanInventory.ExpireDate === '' || scanInventory.ExpireDate === null) ? '' : new Date(scanInventory.ExpireDate);
            this.setState({
              productCount: Number(inventoryRes.length) + Number(selectedQuantity)
            });
          }
        }
      } else {
        scanInventory.ScanDate = moment().tz(timezone).format('YYYY-MM-DD HH:mm:ss.SSS');
        // scanInventory.ScanDate = moment().format('YYYY-MM-DD HH:mm:ss.SSS');
        // scanInventory.SessionDate;
        // scanInventory.SessionDate = moment().tz(timezone).format('YYYY-MM-DD HH:mm:ss.SSS');
        // scanInventory.SessionDate = moment().format('YYYY-MM-DD HH:mm:ss.SSS');
        scanInventory.ExpireDate = (scanInventory.ExpireDate === '' || scanInventory.ExpireDate === null)
          ? '' : moment(scanInventory.ExpireDate).format('MM/DD/YYYY');
        scanInventory.inventoryId = moment().format('_DDMMMYYYY_hhmmss.SSSA');
        scanInventory.Qty = Number(selectedQuantity);
        await insertScanInventory(scanInventory);
        scanInventory.ExpireDate = (scanInventory.ExpireDate === '' || scanInventory.ExpireDate === null) ? '' : new Date(scanInventory.ExpireDate);
        this.setState({
          productCount: inventoryRes.length + 1,
        });
      }
      product.AccountAbb = scanInventory.AccountAbb;
      product.AccountName = scanInventory.AccountName;
      product.AccountNo = scanInventory.AccountNo;
      product.BarcodeType = '';
      product.ExpDateEnterType = '';
      product.ExpireDate = '';
      product.LotBarcode = '';
      product.LotEnterType = '';
      product.LotNo = '';
      product.ProductBarcode = null;
      product.ProductDescription = '';
      product.ProductEnterType = '';
      product.ProductNo = '';
      product.ProductValid = true;
      product.Qty = 1;
      product.SalesRepNo = scanInventory.SalesRepNo;
      product.OfficeName = scanInventory.OfficeName;
      product.ScanDate = scanInventory.ScanDate;
      product.DeviceID = scanInventory.DeviceID;
      product.ScanRep = scanInventory.ScanRep;
      product.SessionID = scanInventory.SessionID;
      product.SessionDate = scanInventory.SessionDate;
      // product.SessionDate = moment().format('YYYY-MM-DD HH:mm:ss.SSS');
      product.SessionName = scanInventory.SessionName;
      product.SessionNewOrOld = 'old';
      product.Submitted = 0;
      product.TeamName = scanInventory.TeamName;
      product.isProduct = scanInventory.isProduct;
      product.isExpire = scanInventory.isExpire;
      product.expiringDay = scanInventory.expiringDay;
      product.startDate = new Date(scanInventory.startDate);
      product.isConsignment = scanInventory.isConsignment;
      setScanInventory(product);
      this.setState({
        product,
        isSkipLot: false,
        selectedQuantity: 1,
        isScanLot: true
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onDeleteAlertConsignment = async () => {
    try {
      const { scanInventory } = this.props;
      const { product, isScanner } = this.state;
      const inventoryRes = await getInventoryBySessionID(scanInventory.SessionID);
      product.AccountAbb = scanInventory.AccountAbb;
      product.AccountName = scanInventory.AccountName;
      product.AccountNo = scanInventory.AccountNo;
      product.BarcodeType = '';
      product.ExpDateEnterType = '';
      product.ExpireDate = '';
      product.LotBarcode = '';
      product.LotEnterType = '';
      product.LotNo = '';
      product.ProductBarcode = null;
      product.ProductDescription = '';
      product.ProductEnterType = '';
      product.ProductNo = '';
      product.ProductValid = true;
      product.Qty = 1;
      product.SalesRepNo = scanInventory.SalesRepNo;
      product.OfficeName = scanInventory.OfficeName;
      product.ScanDate = scanInventory.ScanDate;
      product.DeviceID = scanInventory.DeviceID;
      product.ScanRep = scanInventory.ScanRep;
      product.SessionDate = scanInventory.SessionDate;
      // product.SessionDate = moment().format('YYYY-MM-DD HH:mm:ss.SSS');
      product.SessionID = scanInventory.SessionID;
      product.SessionName = scanInventory.SessionName;
      product.SessionNewOrOld = 'old';
      product.Submitted = 0;
      product.TeamName = scanInventory.TeamName;
      product.isProduct = scanInventory.isProduct;
      product.isExpire = scanInventory.isExpire;
      product.expiringDay = scanInventory.expiringDay;
      product.startDate = new Date(scanInventory.startDate);
      product.isConsignment = scanInventory.isConsignment;
      this.setState({
        productCount: inventoryRes.length,
        ProductNo: '',
        LotNo: '',
        ExpireDate: '',
        selectedQuantity: 1,
        isScanLot: true
      });
      this.alertExpireProductModal.hide();
      if (isScanner === true) {
        window.$('#ProductNoBt').focus();
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickContinueAlertExpireDate = async () => {
    try {
      const { setScanInventory, scanInventory } = this.props;
      const { product, ExpireDate, isScanner } = this.state;
      product.ExpireDate = scanInventory.ExpireDate !== '' ? scanInventory.ExpireDate : ExpireDate;
      product.ExpDateEnterType = scanInventory.ExpDateEnterType === 'SCAN' ? 'SCAN' : 'MANUAL';
      setScanInventory(product);
      this.setState({
        product,
        isScanExpiry: true
      });
      this.alertExpireProductModal.hide();
      if (isScanner === true) {
        window.$('#ProductNoBt').focus();
      }
      if (product.ProductEnterType && product.isConsignment === false) {
        await this._onSaveScanProduct('');
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  // handleClick = () => {
  //   // setTimeout(() => {
  //   //   const myAudio = new Audio(ErrorBeep);
  //   //   myAudio.load();
  //   //   myAudio.play();
  //   //   // new Audio(ErrorBeep).play();
  //   // }, 500);
  //   const source = ErrorBeep;
  //   const audio = document.createElement('audio');
  //   //
  //   audio.autoplay = true;
  //   //
  //   audio.load();
  //   audio.addEventListener('load', () => {
  //     audio.play();
  //   }, true);
  //   audio.src = source;
  // }

  _onFindProductAndLot = async (scanner, type) => {
    try {
      const {
        scanInventory, notify, setScanInventory, setLoader
      } = this.props;
      const {
        productCount, isScanProduct, isSkipLot, selectedQuantity, isScanner
      } = this.state;
      const inventoryRes = await getInventoryBySessionID(scanInventory.SessionID);

      if (Object.keys(scanner).length > 0 && scanner.data !== undefined) {
        const productRes = await findProduct(scanner, scanner.data, inventoryRes);
        const lotScanRes = await findLot(scanner, scanner.data, inventoryRes);
        const lotNoRes = await getConsignmentByProductNoAndLotNo(
          scanInventory.ProductNo, scanInventory.LotNo
        );

        if (scanInventory.ProductNo !== '' && scanInventory.LotNo !== '') {
          await this._onSaveScanProduct('');
        } else if (scanInventory.ProductNo !== '' && scanInventory.isProduct === true) {
          await this._onSaveScanProduct('');
        } else if (scanInventory.ProductNo !== '' && isSkipLot === false) {
          await this._onSaveScanProduct('');
        }

        if (scanInventory.ProductNo === '') {
          if (Object.keys(productRes).length > 0) {
            if ((productRes.ProductNo === undefined)) {
              this.enterProductNoManuallyModal.show();
              if (isScanner === true) {
                // await new Audio(ErrorBeep).play();
                window.$('#playErrorAudio').click();
                window.$('#ProductNoBt').val('');
                window.$('#LotNoBt').val('');
              }
              return;
            }
            if (lotScanRes.ScanType === 'lot') {
              // notify({ type: 'error',
              // message: 'A Lot barcode was scanned. You must scan a Product barcode.', time: 3 });
              this.wrongProductBarCodeScannedModal.show();
              // new Audio(ErrorBeep).play();
              window.$('#playErrorAudio').click();
              return;
            }

            if (productRes.ScanType === 'product') {
              let expiryDate;
              if (productRes.ExpirationDate !== null) {
                expiryDate = moment(productRes.ExpirationDate, 'YYMMDD').format('MM/DD/YYYY');
              }
              scanInventory.ProductNo = productRes.ProductNo;
              scanInventory.ProductDescription = productRes.ProductDescription;
              scanInventory.ProductBarcode = productRes.ProductBarcode === undefined
                ? null
                : productRes.ProductBarcode;
              scanInventory.BarcodeType = productRes.BarcodeType;
              scanInventory.ProductValid = productRes.ProductValid;
              scanInventory.ProductEnterType = type === 'external' ? 'EXTDEVICE' : productRes.ProductEnterType;
              scanInventory.LotNo = productRes.LotNo === undefined ? '' : productRes.LotNo;
              scanInventory.LotEnterType = productRes.LotEnterType === undefined
                ? null : type === 'external' ? 'EXTDEVICE' : productRes.LotEnterType;
              scanInventory.LotBarcode = productRes.LotBarcode === undefined
                ? null : productRes.LotBarcode;
              scanInventory.ExpireDate = (productRes.ExpirationDate === undefined || productRes.ExpirationDate === '' || productRes.ExpirationDate === null)
                ? '' : new Date(expiryDate);
              scanInventory.ExpDateEnterType = productRes.ExpDateEnterType === undefined
                ? null : type === 'external' ? 'EXTDEVICE' : productRes.ExpDateEnterType;
              /* const productCountValue = (scanInventory.isProduct === true)
                ? productCount + 1 : (isSkipLot === false)
                  ? Number(inventoryRes.length) + Number(selectedQuantity)
                  : productCount; */
              scanInventory.Qty = (scanInventory.isProduct === true
                || (scanInventory.ProductNo !== '' && scanInventory.LotNo !== ''))
                ? productCount + 1 : productCount;
              let qty = 0;
              if (selectedQuantity > 1) {
                qty = Number(inventoryRes.length) + Number(selectedQuantity);
              } else {
                qty = productCount;
              }

              this.setState({
                isSkipLot: true,
                product: scanInventory,
                productCount: (scanInventory.isProduct === true
                  || (scanInventory.ProductNo !== '' && scanInventory.LotNo !== ''))
                  ? productCount + 1 : qty
              }, () => {
                setScanInventory(scanInventory);
                if (isScanner === true) {
                  if (scanInventory.ProductNo !== '' && scanInventory.LotNo !== '' && scanInventory.isProduct === false) {
                    if (scanInventory.isExpire === true
                      && scanInventory.ExpireDate <= scanInventory.startDate) {
                      // new Audio(ErrorBeep).play();
                      window.$('#playErrorAudio').click();
                    } else if (lotNoRes === undefined && scanInventory.isConsignment === true) {
                      // new Audio(ErrorBeep).play();
                      window.$('#playErrorAudio').click();
                    } else {
                      // window.$('#ProductNoBt').focus();
                      // new Audio(SuccessBeep).play();
                      window.$('#playSuccessAudio').click();
                      // const interVal = setInterval(() => {
                      // new Audio(SuccessBeep).play(); }, 300);
                      // setTimeout(() => {
                      //   clearInterval(interVal);
                      // }, 900);
                    }
                  } else if (scanInventory.ProductNo !== '' && scanInventory.LotNo !== '' && scanInventory.isProduct === true) {
                    // new Audio(SuccessBeep).play();
                    window.$('#playSuccessAudio').click();
                  } else {
                    // new Audio(SuccessBeep).play();
                    window.$('#playSuccessAudio').click();
                  }
                }
              });
            }
          } else {
            // notify({ type: 'error',
            // message: 'A Lot barcode was scanned, You must scan a Product barcode.', time: 3 });

            this.wrongProductBarCodeScannedModal.show();
            if (isScanner === true) {
              // new Audio(ErrorBeep).play();
              window.$('#playErrorAudio').click();
              window.$('#ProductNoBt').val('');
            }
          }
        } else if (scanInventory.LotNo === '') {
          if (productRes.ScanType === 'product') {
            // notify({ type: 'error',
            // message: 'A Product barcode was scanned. You must scan a Lot barcode.', time: 3 });
            this.wrongLotBarCodeScannedModal.show();
            if (isScanner === true) {
              // new Audio(ErrorBeep).play();
              window.$('#playErrorAudio').click();
            }
            return;
          }
          if (Object.keys(lotScanRes).length > 0) {
            let expiryDate;
            if (lotScanRes.ExpirationDate !== null) {
              // expiryDate = lotScanRes.ExpirationDate.match(/.{1,2}/g);
              expiryDate = moment(lotScanRes.ExpirationDate, 'YYMMDD').format('MM/DD/YYYY');
            }
            // expiryDate = `${expiryDate[1]}/${expiryDate[0]}/${expiryDate[2]}`;
            if (lotScanRes.ScanType === 'lot') {
              scanInventory.LotNo = lotScanRes.LotNo;
              scanInventory.LotEnterType = type === 'external' ? 'EXTDEVICE' : lotScanRes.LotEnterType;
              scanInventory.LotBarcode = lotScanRes.LotBarcode;
              scanInventory.ExpireDate = (lotScanRes.ExpirationDate === undefined || lotScanRes.ExpirationDate === '' || lotScanRes.ExpirationDate === null)
                ? '' : new Date(expiryDate);
              scanInventory.ExpDateEnterType = type === 'external' ? 'EXTDEVICE' : lotScanRes.ExpDateEnterType;
              scanInventory.Qty = productCount + 1;
              this.setState({
                product: scanInventory,
                isSkipLot: false,
                productCount: productCount + 1
              }, () => {
                setScanInventory(scanInventory);
                if (isScanner === true) {
                  // new Audio(SuccessBeep).play();
                  window.$('#playSuccessAudio').click();
                }
              });
            }
          } else if (scanner.scanType === 'lot' && scanInventory.ProductNo !== '') {
            // notify({ type: 'error',
            // message: 'A Product barcode was scanned. You must scan a Lot barcode.', time: 3 });
            this.wrongLotBarCodeScannedModal.show();
            if (isScanner === true) {
              // new Audio(ErrorBeep).play();
              window.$('#playErrorAudio').click();
            }
          } else {
            notify({
              type: 'error',
              message: 'The scanned barcode is invalid. Scan again or enter product number manually.',
              time: 3
            });
            if (isScanner === true) {
              // new Audio(ErrorBeep).play();
              window.$('#playErrorAudio').click();
            }
          }
        }

        // Check product Expiry date & in not in Consignment
        if (scanInventory.ProductNo !== '' && scanInventory.LotNo !== '' && scanInventory.ExpireDate <= scanInventory.startDate) {
          if (isScanner === true) {
            const interVal1 = setInterval(() => {
              clearInterval(interVal1);
              window.$('#ProductNoBt').blur();
              setLoader(true);
            }, 300);
            const interVal2 = setInterval(() => {
              clearInterval(interVal2);
              setLoader(false);
            }, 500);
          }

          if ((scanInventory.ExpireDate !== null || scanInventory.ExpireDate !== '') && scanInventory.isExpire === true
            && scanInventory.ExpireDate <= scanInventory.startDate) {
            this.alertExpireProductModal.show();
            if (scanInventory.isConsignment === true) {
              this.alertExpireProductModal.hide();
              this.alertConsignmentInventoryModal.show();
              return;
            }
          }
        }

        // Check product Expiry date
        if (scanInventory.ProductNo !== '' && scanInventory.LotNo !== '' && scanInventory.ExpireDate <= scanInventory.startDate) {
          // window.$('#ProductNoBt').focus();
          if (isScanner === true && ((scanInventory.ExpireDate !== null || scanInventory.ExpireDate !== '') && scanInventory.isExpire === true
            && scanInventory.ExpireDate <= scanInventory.startDate)) {
            const interVal1 = setInterval(() => {
              clearInterval(interVal1);
              // window.$('#ProductNoBt').blur();
              setLoader(true);
            }, 300);
            const interVal2 = setInterval(() => {
              clearInterval(interVal2);
              setLoader(false);
            }, 500);
          }

          if ((scanInventory.ExpireDate !== null || scanInventory.ExpireDate !== '') && scanInventory.isExpire === true
            && scanInventory.ExpireDate <= scanInventory.startDate) {
            this.alertExpireProductModal.show();
            return;
          }

          if ((scanInventory.ExpireDate !== null || scanInventory.ExpireDate !== '') && scanInventory.isExpire === false
            && scanInventory.ExpireDate <= scanInventory.startDate) {
            setTimeout(() => {
              window.$('#ProductNoBt').focus();
            }, 300);
            return;
          }
        }

        // Check product is in not in Consignment
        // const lotNoRes = await getConsignmentByProductNoAndLotNo(
        //   scanInventory.ProductNo, scanInventory.LotNo
        // );

        if (scanInventory.ProductNo !== '' && scanInventory.LotNo !== '' && scanInventory.isConsignment === true) {
          const lotNoResNew = await getConsignmentByProductNoToArray(
            scanInventory.ProductNo
          );

          // console.log('lotNoResNew', lotNoResNew);
          // console.log('scanInventory', scanInventory);
          const lotResNew = lotNoResNew.filter(
            (item) => (
              item.AccountName.toLowerCase() === scanInventory.AccountName.toLowerCase()
              && item.LotNo === scanInventory.LotNo
            )
          );

          if (lotResNew.length === 0) {
            if (isScanner === true) {
              const interVal1 = setInterval(() => {
                clearInterval(interVal1);
                window.$('#ProductNoBt').blur();
                setLoader(true);
              }, 300);
              const interVal2 = setInterval(() => {
                clearInterval(interVal2);
                setLoader(false);
              }, 500);
            }

            this.alertConsignmentInventoryModal.show();
            return;
          }
        }

        // if (scanInventory.ProductNo !== '' && scanInventory.LotNo !== ''
        //   && scanInventory.ExpireDate !== null && scanInventory.isConsignment === true) {
        //   if (isScanner === true) {
        //     const interVal1 = setInterval(() => {
        //       clearInterval(interVal1);
        //       window.$('#ProductNoBt').blur();
        //       setLoader(true);
        //     }, 300);
        //     const interVal2 = setInterval(() => {
        //       clearInterval(interVal2);
        //       setLoader(false);
        //     }, 500);
        //   }

        //   if (lotNoRes === undefined && scanInventory.isConsignment === true) {
        //     this.alertConsignmentInventoryModal.show();
        //     return;
        //   }
        // }

        const onlyProductNoRes = await getConsignmentByProductNo(scanInventory.ProductNo);
        if (scanInventory.ProductNo !== '' && isScanProduct === true && scanInventory.isProduct === true) {
          if (onlyProductNoRes === undefined && scanInventory.isConsignment === true) {
            this.alertConsignmentInventoryModal.show();
            return;
          }
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _goBack = () => {
    try {
      const { goBack } = this.props;
      onGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onAlertConsignment = async () => {
    const { isSkipLot } = this.state;
    const { scanInventory } = this.props;
    if (isSkipLot === true) {
      this.setState({ isSkipLot: false });
    }
    if (scanInventory.ProductEnterType === 'MANUAL' && scanInventory.isConsignment === true) {
      await this._onSaveScanProduct('');
    }
  }

  _onSkipLot = async () => {
    try {
      const { scanInventory, setScanInventory } = this.props;
      const { product, isSkipLot, isScanner } = this.state;
      const lotNoRes = await getConsignmentByProductNo(scanInventory.ProductNo);
      if (scanInventory.ProductNo !== '' && scanInventory.LotNo === '' && isSkipLot === true && scanInventory.ProductEnterType !== 'MANUAL') {
        if (lotNoRes === undefined && scanInventory.isConsignment === true) {
          this.alertConsignmentInventoryModal.show();
          return;
        }
      }

      if (Object.keys(scanInventory).length > 0) {
        setScanInventory(product);
        if (scanInventory.ProductEnterType === 'MANUAL') {
          this.setState({
            LotNo: '',
            ExpireDate: '',
            selectedQuantity: 1,
            isSkipLot: false,
            isScanLot: true,
            isScanExpiry: true
          });
        } else {
          this.setState({
            LotNo: '',
            ExpireDate: '',
            selectedQuantity: 1,
            isSkipLot: false
          });
        }
        if (isScanner === true) {
          window.$('#ProductNoBt').val('');
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onInsertInventory = async (scanInventory, selectedQuantity) => {
    try {
      const { user: { selectedTeam: { timezone } } } = this.props;
      const inventoryRes = await getInventoryBySessionID(scanInventory.SessionID);
      if ((scanInventory.ProductEnterType === 'MANUAL'
        || scanInventory.LotEnterType === 'MANUAL'
        || scanInventory.ExpDateEnterType === 'MANUAL')
        && selectedQuantity > 1) {
        scanInventory.ScanDate = moment().tz(timezone).format('YYYY-MM-DD HH:mm:ss.SSS');
        // scanInventory.ScanDate = moment().format('YYYY-MM-DD HH:mm:ss.SSS');
        // scanInventory.SessionDate;
        // scanInventory.SessionDate = moment().tz(timezone).format('YYYY-MM-DD HH:mm:ss.SSS');
        // scanInventory.SessionDate = moment().format('YYYY-MM-DD HH:mm:ss.SSS');
        scanInventory.inventoryId = moment().format('_DDMMMYYYY_hhmmss.SSSA');
        scanInventory.ExpireDate = (scanInventory.ExpireDate === '' || scanInventory.ExpireDate === null)
          ? '' : moment(scanInventory.ExpireDate).format('MM/DD/YYYY');
        scanInventory.totalProduct = Number(inventoryRes.length) + 1;
        scanInventory.Qty = Number(selectedQuantity);
        await insertScanInventory(scanInventory);
      } else {
        for (let quantity = 0; quantity < selectedQuantity; quantity++) {
          scanInventory.ScanDate = moment().tz(timezone).format('YYYY-MM-DD HH:mm:ss.SSS');
          // scanInventory.ScanDate = moment().format('YYYY-MM-DD HH:mm:ss.SSS');
          // scanInventory.SessionDate;
          // scanInventory.SessionDate = moment().tz(timezone).format('YYYY-MM-DD HH:mm:ss.SSS');
          // scanInventory.SessionDate = moment().format('YYYY-MM-DD HH:mm:ss.SSS');
          scanInventory.ExpireDate = (scanInventory.ExpireDate === '' || scanInventory.ExpireDate === null)
            ? '' : moment(scanInventory.ExpireDate).format('MM/DD/YYYY');
          scanInventory.totalProduct = Number(inventoryRes.length) + Number(selectedQuantity);
          scanInventory.inventoryId = moment().format('_DDMMMYYYY_hhmmss.SSSA');
          scanInventory.Qty = 1;
          insertScanInventory(scanInventory);
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickDoneModalYes = () => {
    const { goBack } = this.props;
    this.setState({
      ProductNo: '', LotNo: '', ExpireDate: '', isScanProduct: true
    });
    onGoBack(goBack);
  }

  _onProductScanDone = async (value) => {
    try {
      const { scanInventory, goBack, setScanInventoryScanner } = this.props;
      const {
        selectedQuantity, isSkipLot, isScanProduct, isScanner, ProductNo
      } = this.state;
      if (isScanProduct === false && isScanner === false && ProductNo !== '') {
        this.donebtnOnManuaProductModal.show();
        return;
      }
      if (scanInventory.ProductNo !== '' && scanInventory.LotNo !== '') {
        await this._onInsertInventory(scanInventory, selectedQuantity);
      }
      if (scanInventory.ProductNo !== '' && scanInventory.LotNo === '' && scanInventory.isProduct === false && isSkipLot === true) {
        this.productSaveWithoutLotModal.show();
      } else if (scanInventory.ProductNo !== '' && scanInventory.LotNo === '' && isSkipLot === false) {
        await this._onInsertInventory(scanInventory, selectedQuantity);
        onGoBack(goBack);
      } else if ((scanInventory.ProductNo !== '') && scanInventory.isProduct === true) {
        await this._onInsertInventory(scanInventory, selectedQuantity);
        onGoBack(goBack);
      } else {
        onGoBack(goBack);
      }
      this.setState({
        isClickContinue: value
      });
      setScanInventoryScanner({ scanner: false });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onClickScanLot = () => {
    try {
      const { scanInventory, setScanInventory } = this.props;
      const { isScanLot, product } = this.state;
      if (scanInventory.LotNo === '') {
        this.setState({
          isScanLot: !isScanLot
        }, () => {
          if (isScanLot) {
            (!isScanLot) ? window.$('#LotNo').blur() : window.$('#LotNo').focus();
          }
        });
      } else {
        product.LotNo = '';
        product.LotEnterType = '';
        setScanInventory(product);
        this.setState({ LotNo: '', isScanLot: true, product });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onEnterLotNoManually = async () => {
    try {
      const { setScanInventory } = this.props;
      const { LotNo, product } = this.state;
      if (LotNo !== '') {
        product.LotNo = LotNo;
        product.LotEnterType = 'MANUAL';
        product.ExpireDate = '';
        setScanInventory(product);
        // const consignRes = await getConsignmentByProductNoAndLotNo(product.ProductNo, LotNo);
        // if (product.ProductNo !== '' && product.LotNo !== '' && product.isConsignment === true
        // && consignRes === undefined) {
        //   this.alertConsignmentInventoryModal.show();
        //   this.setState({
        //     product
        //   });
        //   return;
        // }
        this.setState({
          product,
          isScanExpiry: false
        });
      } else {
        this.setState({ isScanLot: false, isScanExpiry: false });
      }
      // this._onEnterExpiryManually();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onEnterExpiryManually = async () => {
    try {
      const { setScanInventory } = this.props;
      // const { setScanInventory, scanInventory } = this.props;
      const { ExpireDate, product } = this.state;
      // const lotNoRes = await getConsignmentByProductNoAndLotNo(
      //   scanInventory.ProductNo, scanInventory.LotNo
      // );

      product.ExpireDate = ExpireDate;
      product.ExpDateEnterType = 'MANUAL';
      setScanInventory(product);
      this.setState({
        product,
        // isScanExpiry: true
      });
      // if (scanInventory.ProductNo !== '' && scanInventory.LotNo !== ''
      //     && scanInventory.ExpireDate !== null) {
      //   if (lotNoRes === undefined && scanInventory.isConsignment === true) {
      //     this.alertConsignmentInventoryModal.show();
      //   }
      // }
      // if (scanInventory.ProductNo !== '' && scanInventory.LotNo !== '') {
      //   if ((scanInventory.ExpireDate !== null
      //   || scanInventory.ExpireDate !== '')
      //   && scanInventory.isExpire === true
      //       && ExpireDate <= scanInventory.startDate) {
      //     this.alertExpireProductModal.show();
      //   }
      // }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickScanExpireDate = async () => {
    try {
      const { isScanExpiry } = this.state;
      this.setState({
        isScanExpiry: !isScanExpiry
      }, () => {
        if (isScanExpiry) {
          (!isScanExpiry) ? window.$('#expireDate').blur() : window.$('#expireDate').focus();
        }
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onEnterProductNoManually = async () => {
    try {
      const {
        ProductNo, product, ExpireDate, isScanProduct, isSkipLot, isScanner, isScannerKeyboard,
        isSaveProductBtn
      } = this.state;
      const { setScanInventory, scanInventory } = this.props;
      if (isScanner === true) {
        setTimeout(() => {
          window.$('#ProductNo').focus();
        }, 1000);
        this.setState({ isScannerKeyboard: false, isSaveProductBtn: true });
      }

      const inventoryRes = await getInventoryBySessionID(scanInventory.SessionID);

      if ((ProductNo === '' && isScanProduct === false && isScanner === false) || (ProductNo === '' && isScannerKeyboard === false && isSaveProductBtn === true)) {
        this.productNoRequiredModal.show();
        return;
      }

      const productMasterRes = await getProduct('ProductNo', ProductNo);
      if (Object.keys(productMasterRes).length > 0) {
        // const lotNoRes = await getConsignmentByProductNo(scanInventory.ProductNo);
        // if (ProductNo !== '' && scanInventory.LotNo === '' && scanInventory.isProduct === true) {
        //   if (lotNoRes === undefined && scanInventory.isConsignment === true) {
        //     this.alertConsignmentInventoryModal.show();
        //     // return;
        //   }
        // }
        product.ProductNo = productMasterRes.ProductNo;
        product.ProductEnterType = 'MANUAL';
        product.ProductValid = true;
        product.ProductDescription = productMasterRes.ProductDescription;
        setScanInventory(product);
        this.setState({
          product,
          // isScanProduct: true,
          isScanProduct: false,
          isSkipLot: true,
          isScanLot: false,
          isScanExpiry: false,
          productCount: Number(inventoryRes.length)
        });

        await this._onEnterExpiryManually();
        // Check product Expiry date & in not in Consignment
        if (scanInventory.ProductNo !== '' && scanInventory.LotNo !== '' && ExpireDate !== '') {
          if (scanInventory.isExpire === true && ExpireDate <= scanInventory.startDate) {
            this.alertExpireProductModal.show();

            // if (scanInventory.isConsignment === true) {
            //   this.alertExpireProductModal.hide();
            //   this.alertConsignmentInventoryModal.show();
            //   return;
            // }
          }
        }

        // Check product Expiry date only
        if (scanInventory.ProductNo !== '' && scanInventory.LotNo !== '' && ExpireDate !== '') {
          if (scanInventory.isExpire === true && ExpireDate <= scanInventory.startDate) {
            this.alertExpireProductModal.show();
            return;
          }
        }

        // Check product is in not in Consignment
        const lotNoRes = await getConsignmentByProductNoAndLotNo(
          scanInventory.ProductNo, scanInventory.LotNo
        );
        if (scanInventory.ProductNo !== '' && scanInventory.LotNo !== ''
          && scanInventory.ExpireDate !== null) {
          if (lotNoRes === undefined && scanInventory.isConsignment === true) {
            this.alertConsignmentInventoryModal.show();
            return;
          }
        }

        // Check product is in not in Consignment only Product entered
        const onlyProductNoRes = await getConsignmentByProductNo(scanInventory.ProductNo);
        if (scanInventory.ProductNo !== '' && isScanProduct === true && scanInventory.isProduct === true) {
          if (onlyProductNoRes === undefined && scanInventory.isConsignment === true) {
            this.alertConsignmentInventoryModal.show();
            return;
          }
        }

        if (scanInventory.ProductNo !== '' && scanInventory.isProduct === true) {
          await this._onSaveScanProduct('');
        }

        // Check SkipLot
        if (product.ProductNo !== '' && product.LotNo === '' && isSkipLot === true && product.isProduct === false) {
          this.productSaveWithoutLotModal.show();
          return;
        }
        await this._onSaveManualProduct();
      } else if (ProductNo !== '') {
        this._onManualProductWarnModal();
      } else {
        this.setState({ isScanProduct: true });
      }
      // this.setState({ isScanProduct: true });
      // if (Object.keys(productMasterRes).length === 0 && isScanProduct === false
      // && ProductNo !== '') {
      // this._onManualProductWarnModal();
      // this.manuallyProductWarnModal.show();
      // }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onManualProductWarnModal = () => {
    try {
      this.manuallyProductWarnModal.show();
      this.setState({ isScanLot: false });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickContinueConsignmentAlert = async () => {
    try {
      const { scanInventory } = this.props;
      const { ProductNo } = this.state;
      const lotNoRes = await getConsignmentByProductNo(scanInventory.ProductNo);
      if (ProductNo !== '' && scanInventory.LotNo === '' && scanInventory.isProduct === true) {
        if (lotNoRes === undefined && scanInventory.isConsignment === true) {
          this.manuallyProductWarnModal.hide();
          this.alertConsignmentInventoryModal.show();
          // return;
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickScanProduct = () => {
    try {
      const {
        isScanProduct, product, productCount
      } = this.state;
      const { scanInventory, setScanInventory } = this.props;
      if (scanInventory.ProductNo === '') {
        this.setState({
          isScanProduct: !isScanProduct
        }, () => {
          if (isScanProduct) {
            (!isScanProduct) ? window.$('#ProductNo').blur() : window.$('#ProductNo').focus();
          }
        });
      } else {
        if (productCount !== 0) {
          this.setState({
            productCount: (productCount === scanInventory.Qty && scanInventory.Qty !== 0 && (scanInventory.ProductNo !== '' && scanInventory.LotNo !== ''))
              ? scanInventory.Qty - 1
              : (productCount === scanInventory.Qty && scanInventory.isProduct === false)
                ? productCount
                : (productCount === scanInventory.Qty && scanInventory.isProduct === true)
                  ? scanInventory.Qty - 1 : productCount,
          });
        }
        product.AccountAbb = scanInventory.AccountAbb;
        product.AccountName = scanInventory.AccountName;
        product.AccountNo = scanInventory.AccountNo;
        product.BarcodeType = '';
        product.ExpDateEnterType = '';
        product.ExpireDate = '';
        product.LotBarcode = '';
        product.LotEnterType = '';
        product.LotNo = '';
        product.ProductBarcode = null;
        product.ProductDescription = '';
        product.ProductEnterType = '';
        product.ProductNo = '';
        product.ProductValid = true;
        product.Qty = productCount;
        product.SalesRepNo = scanInventory.SalesRepNo;
        product.ScanDate = scanInventory.ScanDate;
        product.DeviceID = scanInventory.DeviceID;
        product.ScanRep = scanInventory.ScanRep;
        product.SessionID = scanInventory.SessionID;
        product.SessionName = scanInventory.SessionName;
        product.OfficeName = scanInventory.OfficeName;
        product.SessionDate = scanInventory.SessionDate;
        // product.SessionDate = moment().format('YYYY-MM-DD HH:mm:ss.SSS');
        product.SessionNewOrOld = scanInventory.SessionNewOrOld;
        product.Submitted = 0;
        product.TeamName = scanInventory.TeamName;
        product.isProduct = scanInventory.isProduct;
        product.isExpire = scanInventory.isExpire;
        product.expiringDay = scanInventory.expiringDay;
        product.startDate = new Date(scanInventory.startDate);
        product.isConsignment = scanInventory.isConsignment;
        setScanInventory(product);
        this.setState({
          product,
          isSkipLot: false,
          ProductNo: '',
          isScanProduct: true,
          LotNo: '',
          ExpireDate: '',
          isScanLot: true
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onEnterProduct = async (event) => {
    try {
      const { target: { value } } = event;
      const { isScanner } = this.state;
      if (isScanner === true) {
        this.setState({ isScanProduct: false, isSaveProductBtn: true });
      }
      const productNo = value;
      if (productNo !== '') {
        this.setState({
          ProductNo: productNo.split('-').join('').split(' ').join('')
            .toUpperCase(),
          isSkipLot: true,
          isScanLot: false,
          isScanExpiry: false
        });
      } else if (productNo.length === 0) {
        this.setState({
          ProductNo: ''
        });
      }
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onEnterLot = (e) => {
    try {
      const lotNo = e.target.value;
      if (lotNo !== '') {
        this.setState({ LotNo: lotNo });
      } else if (lotNo.length === 0) {
        this.setState({
          LotNo: ''
        });
      }
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onContinue = async () => {
    try {
      const { goBack } = this.props;
      const { isClickContinue, isScanner } = this.state;
      await this._onSaveScanProduct('');
      this.productSaveWithoutLotModal.hide();
      if (isClickContinue === 'done') {
        onGoBack(goBack);
      } else if (isClickContinue === 'editSession') {
        this._onRedirectToEditSession();
      } else if (isClickContinue === 'viewInventory') {
        this._onRedirectToViewInventory();
      }
      if (isScanner === true) {
        this.setState({ isScanProduct: true, isSaveProductBtn: false, isScanExpiry: true });
        window.$('#ProductNoBt').focus();
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickContinue = async () => {
    try {
      const { setScanInventory, scanInventory } = this.props;
      const {
        ProductNo, product, isSkipLot, ExpireDate, isScanProduct
      } = this.state;
      product.ProductNo = ProductNo;
      product.ProductEnterType = 'MANUAL';
      product.ProductValid = false;
      product.ProductDescription = '';
      setScanInventory(product);
      this.setState({
        product,
        isScanProduct: false,
        // isScanProduct: true,
        isSkipLot: true
      });
      await this._onEnterExpiryManually();
      if (ProductNo !== '' && product.LotNo === '' && product.ProductEnterType === 'MANUAL'
        && product.isProduct === false) {
        this.productSaveWithoutLotModal.show();
      } else {
        await this._onSaveManualProduct();
      }
      // Check product Expiry date & in not in Consignment
      if (scanInventory.ProductNo !== '' && scanInventory.LotNo !== '' && ExpireDate !== '') {
        if (scanInventory.isExpire === true && ExpireDate <= scanInventory.startDate) {
          this.alertExpireProductModal.show();
          if (scanInventory.isConsignment === true) {
            this.alertExpireProductModal.hide();
            this.alertConsignmentInventoryModal.show();
            return;
          }
        }
      }

      // Check product Expiry date only
      if (scanInventory.ProductNo !== '' && scanInventory.LotNo !== '' && ExpireDate !== '') {
        if (scanInventory.isExpire === true && ExpireDate <= scanInventory.startDate) {
          this.alertExpireProductModal.show();
          return;
        }
      }

      // Check product is in not in Consignment
      const lotNoRes = await getConsignmentByProductNoAndLotNo(
        scanInventory.ProductNo, scanInventory.LotNo
      );
      if (scanInventory.ProductNo !== '' && scanInventory.LotNo !== ''
        && scanInventory.ExpireDate !== null) {
        if (lotNoRes === undefined && scanInventory.isConsignment === true) {
          this.alertConsignmentInventoryModal.show();
          return;
        }
      }

      // Check product is in not in Consignment only Product entered
      const onlyProductNoRes = await getConsignmentByProductNo(scanInventory.ProductNo);
      if (scanInventory.ProductNo !== '' && isScanProduct === true && scanInventory.isProduct === true) {
        if (onlyProductNoRes === undefined && scanInventory.isConsignment === true) {
          this.alertConsignmentInventoryModal.show();
          return;
        }
      }

      // Check SkipLot
      if (product.ProductNo !== '' && product.LotNo === '' && isSkipLot === true && product.isProduct === false) {
        this.productSaveWithoutLotModal.show();
        return;
      }

      if ((ProductNo !== '' && isSkipLot === true) || (ProductNo !== '' && product.isProduct === true && product.ProductEnterType !== 'MANUAL')) {
        await this._onClickContinueConsignmentAlert();
      }
      if (ProductNo !== '' && product.ProductEnterType === 'MANUAL' && product.isProduct === true) {
        await this._onSaveScanProduct('');
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onTryAgain = async () => {
    try {
      window.$('#ProductNo').focus();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onBadBarcode = async () => {
    try {
      const { isScanner } = this.state;
      if (isScanner === true) {
        window.$('#ProductNoBt').val('');
        this.setState({ isScannerKeyboard: true, isScanProduct: false });
        // setTimeout(() => {
        //   window.$('#ProductNo').focus();
        // }, 1000);
      } else {
        this.setState({
          isScanProduct: false,
        }, () => {
          window.$('#ProductNo').focus();
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onChangeQuantity = (e) => {
    try {
      if (e.target.value === '') {
        this.productQuantityModal.show();
        this.setState({
          selectedQuantity: ''
        });
      } else if (e.target.value === '0') {
        this.productQuantityModal.show();
        this.setState({
          selectedQuantity: 0
        }, () => this._onClickOk());
      } else if (e.target.value >= 1) {
        this.setState({
          selectedQuantity: e.target.value
        });
      }
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onClickOk = async () => {
    try {
      const { selectedQuantity } = this.state;
      window.$('#quantity').focus();
      if (selectedQuantity === 0) {
        this.setState({ selectedQuantity: 1 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGoBack = () => {
    try {
      const { goBack, setGoBack } = this.props;
      goBack.push(window.location.pathname);
      setGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onEditSession = async (editSession) => {
    try {
      this.setState({
        isClickContinue: editSession
      }, async () => {
        await this._onProductScanEditSession(editSession);
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClearProduct = () => {
    const { scanInventory, setScanInventory } = this.props;
    const { product, productCount } = this.state;
    product.AccountAbb = scanInventory.AccountAbb;
    product.AccountName = scanInventory.AccountName;
    product.AccountNo = scanInventory.AccountNo;
    product.BarcodeType = '';
    product.ExpDateEnterType = '';
    product.ExpireDate = '';
    product.LotBarcode = '';
    product.LotEnterType = '';
    product.LotNo = '';
    product.ProductBarcode = null;
    product.ProductDescription = '';
    product.ProductEnterType = '';
    product.ProductNo = '';
    product.ProductValid = true;
    product.Qty = productCount;
    product.SalesRepNo = scanInventory.SalesRepNo;
    product.ScanDate = scanInventory.ScanDate;
    product.DeviceID = scanInventory.DeviceID;
    product.ScanRep = scanInventory.ScanRep;
    product.SessionID = scanInventory.SessionID;
    product.SessionName = scanInventory.SessionName;
    product.OfficeName = scanInventory.OfficeName;
    product.SessionDate = scanInventory.SessionDate;
    // product.SessionDate = moment().format('YYYY-MM-DD HH:mm:ss.SSS');
    product.SessionNewOrOld = scanInventory.SessionNewOrOld;
    product.Submitted = 0;
    product.TeamName = scanInventory.TeamName;
    product.isProduct = scanInventory.isProduct;
    product.isExpire = scanInventory.isExpire;
    product.expiringDay = scanInventory.expiringDay;
    product.startDate = new Date(scanInventory.startDate);
    product.isConsignment = scanInventory.isConsignment;
    setScanInventory(product);
    this.setState({
      product,
    });
  }

  _onRedirectToEditSession = () => {
    const { setSingleScanSession, scanInventory } = this.props;
    setSingleScanSession(scanInventory);
    this._onGoBack();
    browserHistory.push('/inventory/consignment/scan-session/edit-session');
  }

  _onRedirectToViewInventory = () => {
    const { setSingleScanSession, scanInventory } = this.props;
    setSingleScanSession(scanInventory);
    this._onGoBack();
    browserHistory.push('/inventory/consignment/scan-session/scan-view-inventory');
  }

  _onProductScanEditSession = async () => {
    try {
      const { scanInventory } = this.props;
      const { selectedQuantity, isSkipLot, isClickContinue } = this.state;
      if (scanInventory.ProductNo !== '' && scanInventory.LotNo !== '') {
        await this._onInsertInventory(scanInventory, selectedQuantity);
        await this._onClearProduct();
        if (isClickContinue === 'editSession') {
          await this._onRedirectToEditSession();
        } else {
          await this._onRedirectToViewInventory();
        }
      } else if (scanInventory.ProductNo !== '' && scanInventory.LotNo === '' && isSkipLot === false) {
        await this._onInsertInventory(scanInventory, selectedQuantity);
        await this._onClearProduct();
        if (isClickContinue === 'editSession') {
          await this._onRedirectToEditSession();
        } else {
          await this._onRedirectToViewInventory();
        }
      } else if ((scanInventory.ProductNo !== '') && scanInventory.isProduct === true) {
        await this._onInsertInventory(scanInventory, selectedQuantity);
        await this._onClearProduct();
        if (isClickContinue === 'editSession') {
          await this._onRedirectToEditSession();
        } else {
          await this._onRedirectToViewInventory();
        }
      } else if (scanInventory.ProductNo !== '' && scanInventory.LotNo === '' && scanInventory.isProduct === false && isSkipLot === true) {
        this.productSaveWithoutLotModal.show();
      } else if (isClickContinue === 'editSession') {
        await this._onRedirectToEditSession();
      } else {
        await this._onRedirectToViewInventory();
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onViewInventory = async (editSession) => {
    try {
      this.setState({
        isClickContinue: editSession
      }, async () => {
        await this._onProductScanEditSession(editSession);
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onExternalProductScan = async () => {
    const $this = this;
    if (!$this.isScanProgress) {
      $this.isScanProgress = true;
      setTimeout(async () => {
        const { scanInventory } = $this.props;
        const scannerValue = window.$('#ProductNoBt').val();
        const scanData = { data: scannerValue, key: 0 };
        await $this._onFindProductAndLot(scanData, 'external');
        $this.isScanProgress = false;
        if (scanInventory.ProductNo !== '' && scanInventory.LotNo === '') {
          setTimeout(() => {
            window.$('#LotNoBt').focus();
          }, 100);
        }
        if (scanInventory.ProductNo !== '' && scanInventory.LotNo !== '') {
          window.$('#ProductNoBt').val('');
          window.$('#LotNoBt').val('');
        }
        if (scanInventory.ProductNo !== '' && scanInventory.isProduct === true) {
          window.$('#ProductNoBt').val('');
        }
      }, $this.props.scanInventory.isProduct === true ? 300 : 900);
      // }, 900);
    }
  }

  _onExternalLotScan = async () => {
    const $this = this;
    if (!$this.isScanProgress) {
      $this.isScanProgress = true;
      setTimeout(async () => {
        const { scanInventory } = this.props;
        const scannerValue = window.$('#LotNoBt').val();
        const scanData = { data: scannerValue, key: 0 };
        await $this._onFindProductAndLot(scanData, 'external');
        $this.isScanProgress = false;
        if (scanInventory.ProductNo !== '' && scanInventory.LotNo !== '') {
          window.$('#ProductNoBt').val('');
          window.$('#LotNoBt').val('');
        }
        setTimeout(() => {
          window.$('#ProductNoBt').focus();
        }, 100);
      }, 900);
    }
  }

  _onSaveManualProduct = async () => {
    try {
      const { scanInventory } = this.props;
      const {
        ExpireDate, product, isSkipLot, isScanProduct, ProductNo, isScanner
      } = this.state;

      if (isScanner === true) {
        window.$('#ProductNoBt').focus();
        this.setState({
          isScannerKeyboard: false,
          isSaveProductBtn: false,
          isScanExpiry: true
        });
      } else {
        this.setState({ isScanProduct: true });
      }

      if (ProductNo === '') {
        this.productNoRequiredModal.show();
        return;
      }
      await this._onEnterExpiryManually();
      // Check product Expiry date & in not in Consignment
      if (scanInventory.ProductNo !== '' && scanInventory.LotNo !== '' && ExpireDate !== '') {
        if (scanInventory.isExpire === true && ExpireDate <= scanInventory.startDate) {
          this.alertExpireProductModal.show();
          if (scanInventory.isConsignment === true) {
            this.alertExpireProductModal.hide();
            this.alertConsignmentInventoryModal.show();
            return;
          }
        }
      }

      // Check product Expiry date only
      if (scanInventory.ProductNo !== '' && scanInventory.LotNo !== '' && ExpireDate !== '') {
        if (scanInventory.isExpire === true && ExpireDate <= scanInventory.startDate) {
          this.alertExpireProductModal.show();
          return;
        }
      }

      // Check product is in not in Consignment
      const lotNoRes = await getConsignmentByProductNoAndLotNo(
        scanInventory.ProductNo, scanInventory.LotNo
      );
      if (scanInventory.ProductNo !== '' && scanInventory.LotNo !== ''
        && scanInventory.ExpireDate !== null) {
        if (lotNoRes === undefined && scanInventory.isConsignment === true) {
          this.alertConsignmentInventoryModal.show();
          return;
        }
      }

      // Check product is in not in Consignment only Product entered
      const onlyProductNoRes = await getConsignmentByProductNo(scanInventory.ProductNo);
      if (scanInventory.ProductNo !== '' && isScanProduct === true && scanInventory.isProduct === true) {
        if (onlyProductNoRes === undefined && scanInventory.isConsignment === true) {
          this.alertConsignmentInventoryModal.show();
          return;
        }
      }

      // Check SkipLot
      if (product.ProductNo !== '' && product.LotNo === '' && isSkipLot === true && product.isProduct === false) {
        this.productSaveWithoutLotModal.show();
        return;
      }

      if (scanInventory.ProductNo !== '' && scanInventory.LotNo !== '') {
        await this._onSaveScanProduct('');
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onOkWrongProductBarCode = () => {
    try {
      window.$('#ProductNoBt').val('');
      window.$('#ProductNoBt').focus();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onOkWrongLotBarCode = () => {
    try {
      window.$('#LotNoBt').val('');
      window.$('#LotNoBt').focus();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  playErrorAudio = () => {
    const audio = document.getElementById('errorAudio');
    audio.play();
  }

  playSuccessAudio = () => {
    const audio = document.getElementById('successAudio');
    audio.play();
  }

  render() {
    const {
      productCount, product, isScanProduct, ProductNo, LotNo, isScanLot, ExpireDate,
      isScanExpiry, isSkipLot, selectedQuantity, isScanner, isScannerKeyboard,
      isSaveProductBtn, scanPaused
    } = this.state;
    const { scanInventory, params: { id } } = this.props;
    return (
      <section className="list-section resizer-class">
        <div className="d-none">
          <input id="playErrorAudio" type="button" value="PLAY" onClick={this.playErrorAudio} />
          <audio id="errorAudio" src={`${ErrorBeep}`}>
            <source src={`${ErrorBeep}`} type="audio/mpeg" />
          </audio>
          <input id="playSuccessAudio" type="button" value="PLAY" onClick={this.playSuccessAudio} />
          <audio id="successAudio" src={`${SuccessBeep}`}>
            <source src={`${SuccessBeep}`} type="audio/mpeg" />
          </audio>
        </div>
        {
          !isScanner
          && (
            <div className={`${screenWidth <= 800 ? 'camera-wrap-small' : 'camera-wrap'}`}>
              <Scanner
                onScan={this._onScan}
                setPaused={(newValue) => this.setState({ scanPaused: newValue })}
                paused={scanPaused}
              />
            </div>
          )
        }
        {
          isScanner
          && (
            <div className="container camera-wrap">
              <div className="row gx-2">
                <p>External Bluetooth Scanner</p>
                <div className="col-12 mb-3">
                  <input
                    className="form-control view-int-input" type="text"
                    name="Product"
                    id="ProductNoBt"
                    placeholder="Scan product barcode"
                    onChange={() => this._onExternalProductScan()}
                  // onBlur={this._onAddExternalProduct}
                  />
                </div>
                {
                  product.isProduct === false
                  && (
                    <div className="col-12">
                      <input
                        className="form-control view-int-input" type="text"
                        name="Lot"
                        id="LotNoBt"
                        placeholder="Scan lot barcode"
                        onChange={() => this._onExternalLotScan()}
                      />
                    </div>
                  )
                }
              </div>
            </div>
          )
        }
        <section className="case-details-section pb-0 scan-scroll">
          <div className="container">
            <div className="row gx-2">
              <div className="col-4">
                <p>Products: {productCount}</p>
              </div>
              <div className="col-4">
                <button
                  type="button"
                  className={`btn btn-theme-alt btn-theme-outline-alt w-100 ${!isScanner ? 'active' : ''}`}
                  onClick={this._onScanner}
                  disabled={isScanner === false}
                >Camera
                </button>
              </div>
              <div className="col-4">
                <button
                  type="button"
                  className={`btn btn-theme-alt btn-theme-outline-alt w-100 ${isScanner ? 'active' : ''}`}
                  onClick={this._onScanner}
                  disabled={isScanner === true}
                >Scanner
                </button>
              </div>
            </div>
            <hr />
            <div className="row gx-2 mb-3">
              <div className="col-6">
                <button
                  type="button"
                  className="btn btn-theme-alt btn-theme-outline-alt w-100"
                  disabled={(productCount === 0)}
                  onClick={() => this._onEditSession('editSession')}
                >Edit Session
                </button>
              </div>
              <div className="col-6">
                <button
                  type="button"
                  className="btn btn-theme-alt btn-theme-outline-alt w-100"
                  onClick={() => this._onViewInventory('viewInventory')}
                  disabled={(productCount === 0)}
                >View Inventory
                </button>
              </div>
            </div>
            <div className="row gx-2">
              <div className="col">
                <input
                  className="form-control view-int-input ProductNo class-product" type="text"
                  name="Product"
                  id="ProductNo"
                  value={isScanProduct === true ? product.ProductNo
                    : (isScanProduct === false && isScanner === true && isScannerKeyboard === false
                      && isSaveProductBtn === false)
                      ? product.ProductNo
                      : (isScanProduct === false && isScanner === true
                        && isScannerKeyboard === false && isSaveProductBtn === true)
                        ? ProductNo
                        : (isScanProduct === false && isScanner === true
                          && isScannerKeyboard === true && isSaveProductBtn === false)
                          ? product.ProductNo
                          : (isScanProduct === true && isScanner === true
                            && isScannerKeyboard === false && isSaveProductBtn === true)
                            ? ProductNo
                            : ProductNo}
                  placeholder="Product #"
                  onChange={(e) => { this._onEnterProduct(e); }}
                  disabled={(isScanProduct === true && isScanner === false)
                    || (isScanner === true && isSaveProductBtn === false)}
                // onBlur={ProductNo !== '' ? this._onEnterProductNoManually : () => {}}
                />
              </div>
              <div className="col-auto">
                <button className="btn input-group-icon-button pe-0" type="button">
                  <i
                    className={`icon-right ${
                      // ((product.ProductNo === '' && product.ProductBarcode === null)
                      // && isScanProduct === true && isScanner === false)
                      (((product.ProductNo === '' && product.ProductBarcode === null) && isScanProduct === true && isScanner === false)
                        || (product.ProductNo === '' && product.ProductBarcode === null && isScanner === true && isScannerKeyboard === true))
                        ? 'fas fa-keyboard'
                        : (product.ProductNo === '' && product.ProductBarcode === null && isScanProduct === true && isScanner === true)
                          ? ''
                          : (product.ProductNo !== '' && product.LotNo === '' && product.ProductEnterType !== 'MANUAL')
                            ? 'fas fa-trash trash-color'
                            : (product.ProductNo !== '' && product.LotNo !== '' && product.ProductEnterType !== 'MANUAL')
                              ? 'fas fa-trash trash-color'
                              // : (isScanProduct === false
                              // && product.ProductNo === ''
                              // && isScanner === false)
                              //   ? 'fas fa-check'
                              : ''}`}
                    onClick={isScanProduct === false && product.ProductNo === ''
                      ? this._onEnterProductNoManually : this._onClickScanProduct}
                  />
                </button>
                <button className="btn input-group-icon-button pe-0" type="button">
                  <i
                    className={`icon-right ${(
                      (product.ProductNo !== '' && product.LotNo === '' && product.ExpireDate !== '' && isScanProduct === true)
                    )
                      ? 'fas fa-plus'
                      : (
                        product.ProductNo !== '' && product.LotNo !== '' && isScanProduct === true && product.ProductEnterType === 'MANUAL'
                      )
                        ? ''
                        : (
                          (product.ProductNo !== '' && product.LotNo !== '' && (product.ExpireDate !== '' || product.ExpireDate !== null) && isScanProduct === true)
                        )
                          ? 'fas fa-plus'
                          : (
                            product.ProductNo !== '' && product.isProduct === false && isSkipLot === false
                          )
                            ? 'fas fa-plus'
                            : (
                              product.ProductNo !== '' && product.isProduct === true && isScanProduct === true && product.ProductEnterType !== 'MANUAL'
                            )
                              ? 'fas fa-plus'
                              : (
                                product.ProductNo !== '' && isScanner === true && (product.isProduct === true || product.isProduct === false)
                              )
                                ? 'fas fa-plus'
                                : (
                                  product.ProductNo === '' && product.ProductBarcode === null && isScannerKeyboard === false && isScanner === true && isScanProduct === false
                                )
                                  ? ''
                                  : ''}`}
                    onClick={() => this._onSaveScanProduct('plus')}
                  />
                </button>
              </div>
              <div className="col-12 mt-2">
                {/* <p>{`${((product.ProductNo === ''
                || product.ProductNo === undefined || ProductNo === '')) */}
                {/*    ? 'Product description would go here, not editable'
                : product.ProductDescription}`} */}
                {/* </p> */}
                <p>{`${product.ProductDescription}`}</p>
                <p />
              </div>
            </div>
            {
              scanInventory.isProduct === false
              && (
                <div className="row gx-2 mb-3">
                  <div className="col">
                    <input
                      className="form-control view-int-input"
                      type="text"
                      name="LotNo"
                      id="LotNo"
                      value={isScanLot === true ? product.LotNo : LotNo}
                      placeholder="Lot #"
                      onChange={(e) => { this._onEnterLot(e); }}
                      disabled={isScanLot === true}
                      onBlur={this._onEnterLotNoManually}
                    />
                  </div>
                  <div className="col-auto">
                    <button className="btn input-group-icon-button" type="button">
                      {
                        (product.ProductNo !== '')
                        && (
                          <i
                            className={`icon-right ${(isScanLot === true && product.LotNo === '' && product.ProductNo !== '' && isScanner === false && product.ProductEnterType === 'SCAN')
                              ? 'fas fa-keyboard'
                              : (isScanLot === false && product.LotNo === '' && product.ProductEnterType === 'SCAN')
                                ? 'fas fa-check'
                                : (product.LotNo !== '' && product.LotEnterType === 'SCAN')
                                  ? ''
                                  : (isScanner === true) ? ''
                                    : ''}`}
                            onClick={isScanLot === false && product.LotNo === ''
                              ? this._onEnterLotNoManually : this._onClickScanLot}
                          />
                        )
                      }
                    </button>
                  </div>
                </div>
              )
            }

            <div className="row gx-2 mb-5">
              {
                scanInventory.isProduct === false && (
                  <div className="col">
                    <DatePicker
                      dateFormat="MM/dd/yyyy"
                      style={{ maxWidth: '50px' }}
                      className="form-control view-int-input"
                      placeholderText="Expiry Date(Optional)"
                      id="expireDate"
                      selected={isScanExpiry === true ? product.ExpireDate : ExpireDate}
                      onChangeRaw={(e) => {
                        e.preventDefault();
                      }}
                      onChange={(value) => {
                        this.setState({ ExpireDate: value });
                      }}
                      minDate={new Date()}
                      disabled={isScanExpiry === true}
                    />
                  </div>
                )
              }

              {/* { */}
              {/*    (scanInventory.isProduct === false) && ( */}
              {/*      <div className="col-auto"> */}
              {/*        <button className="btn input-group-icon-button" type="button"> */}
              {/*          { */}
              {/*  (product.ProductNo !== '') */}
              {/*  && ( */}
              {/*  <i */}
              {/*    className={`icon-right ${ */}
              {/*      (isScanExpiry === true && product.ExpireDate === '') */}
              {/*        ? 'fas fa-keyboard' */}
              {/*        : (isScanExpiry === false && product.ExpireDate === '') */}
              {/*          ? 'fas fa-check' */}
              {/*          : ''}`} */}
              {/*    onClick={(isScanExpiry === false && product.ExpireDate === '') */}
              {/*      ? this._onEnterExpiryManually : this._onClickScanExpireDate} */}
              {/*  /> */}
              {/*  ) */}
              {/* } */}
              {/*        </button> */}
              {/*      </div> */}
              {/*    ) */}
              {/* } */}

              {
                scanInventory.isProduct === true && <div className="col-10" />
              }

              <div className={`${scanInventory.isProduct === true ? 'col-2' : 'col-2'}`}>
                <input
                  className="form-control view-int-input text-center" type="number"
                  name="quantity"
                  id="quantity"
                  placeholder="Quantity"
                  returnKeyType="next"
                  value={selectedQuantity}
                  disabled={(
                    (product.ProductNo === '' && isSkipLot === false && product.LotNo === '')
                    || (product.ProductNo !== '' && isSkipLot === true && product.LotNo !== '' && product.ProductEnterType === 'SCAN' && product.BarcodeType !== 'GS1 2D')
                    || (product.ProductNo !== '' && isSkipLot === false && product.LotNo !== '' && product.ProductEnterType === 'MANUAL')
                    || (product.ProductNo !== '' && isSkipLot === false && product.LotNo === '')
                    || (product.ProductNo !== '' && isSkipLot === true && product.LotNo === '')
                    || (product.ProductNo !== '' && product.isProduct === true)
                  )}
                  onChange={(e) => { this._onChangeQuantity(e); }}
                />
              </div>
            </div>

            {/* Visible while Manual Product enter */}
            {
              (
                (isScanProduct === false && product.ProductNo === '' && isScanner === false)
                || (product.ProductEnterType === 'MANUAL' && isScanner === false)
                || (isScanner === true && isSaveProductBtn === true && isScannerKeyboard === false)
              )
              && (
                <div className="row mb-3">
                  <div className="col-12">
                    <button
                      type="button" className="btn btn-theme-alt btn-theme-outline-alt active w-100"
                      onClick={() => this._onEnterProductNoManually()}
                    // onClick={() => this._onSaveManualProduct()}
                    >Save Product
                    </button>
                  </div>
                </div>
              )
            }

            <div className="row mb-3">
              <div className="col-4">
                <button type="button" className="btn btn-theme-alt btn-theme-outline-alt w-100" onClick={() => this._onProductScanDone('done')}>Done</button>
              </div>

              <div className="col-4">
                <button
                  type="button"
                  className="btn btn-theme-alt btn-theme-outline-alt w-100"
                  onClick={() => this.setState({ scanPaused: false })}
                  disabled={isScanProduct === false || scanPaused === false}
                >Scan
                </button>
              </div>

              {
                scanInventory.isProduct === true
                  ? (
                    <div className="col-4">
                      <button
                        type="button"
                        className="btn btn-theme-alt btn-theme-outline-alt w-100"
                        disabled
                        onClick={this._onSkipLot}
                      >Skip Lot
                      </button>
                    </div>
                  )
                  : (
                    <div className="col-4">
                      <button
                        type="button"
                        className={`btn w-100 ${isSkipLot === false ? 'disable-btn-theme-alt btn-theme-outline-alt' : 'btn-theme-alt btn-theme-outline-alt'}`}
                        disabled={isSkipLot === false || (isSkipLot === true && isSaveProductBtn === false) || product.ExpireDate !== ''}
                        onClick={this._onSkipLot}
                      >Skip Lot
                      </button>
                    </div>
                  )
              }
            </div>
          </div>
        </section>

        <ProductSaveWithoutLot
          onContinue={this._onContinue}
        />
        <ManuallyProductWarnModal
          onClickContinue={this._onClickContinue}
          onClickTryAgain={this._onTryAgain}
        />
        <AlertConsignmentInventoryModal
          onDeleteAlertConsignment={this._onDeleteAlertConsignment}
          onClickContinueAlertConsignment={this._onAlertConsignment}
        />
        <AlertExpireProductModal
          onDeleteAlertExpireDate={this._onDeleteAlertConsignment}
          onContinue={this._onClickContinueAlertExpireDate}
        />
        <EnterProductNoManually id={id} onOK={this._onBadBarcode} />
        <ProductQuantityModal onClickOk={this._onClickOk} />
        <ProductNoRequiredModal
          onClickOk={this._onTryAgain}
        />
        <DoneBtnOnManualProductModal
          onClickDoneModalYes={this._onClickDoneModalYes}
        />
        <WrongProductBarCodeScanned
          onClickOk={this._onOkWrongProductBarCode}
        />
        <WrongLotBarCodeScanned
          onClickOk={this._onOkWrongLotBarCode}
        />
      </section>
    );
  }
}

export default withScanInventoryScanner(
  withSingleScanSession(
    withUser(
      withScanInventory(
        withGoBack(
          withNotify(
            withLoader(
              withOnline(
                ScanInventory
              )
            )
          )
        )
      )
    )
  )
);
